export const constants = {
    isTouch: "ontouchstart" in window ? function() {
        document.body.classList.add("touch");
        return true;
    }() : function() {
        document.body.classList.add("no-touch");
        return false;
    }(),
    body: $("body")
};

export function navFunction() {
    let windowScroll;
    let windowW;
    $(window).on('load resize', function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });


    $(window).on('load resize scroll', function(event) {
        windowScroll = $(window).scrollTop();
        windowW = $(window).outerWidth();
        let header = $('.header');
        if (windowScroll > 0) {
            header.addClass('scrolled');
        }
        if (windowScroll <= 0) {
            header.removeClass('scrolled');
        }

    });

    $('.hamburger').on('click', function(event) {
        $(this).toggleClass('open');
        $('.header').toggleClass('menu-open');
        $('body').toggleClass('scroll-lock');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/module.js